module.exports = new __parcel__URL__("objectives_icon.9bd84dd5.png").toString();